<template>
  <div>
    <div class="mb-3 text-center">
      <router-link
        to="/marketplace"
        class="btn btn-dark btn-pill px-4 px-md-3 mr-2 btn-sm mb-2"
        >Fresh</router-link
      >
      <router-link
        to="/marketplace"
        class="btn btn-dark btn-pill px-3 px-md-3 btn-sm mb-2"
        >Processed</router-link
      >
    </div>
    <div
      class="nav flex-column nav-pills text-center marketplace-tabswitch"
      id="v-pills-tab"
      role="tablist"
      aria-orientation="vertical"
    >
      <p class="nav-link disabled mb-0">
        <strong class="text-dark">Categories</strong>
      </p>
      <a
        class="nav-link active"
        id="v-pills-commodities-tab"
        data-toggle="pill"
        href="#v-pills-commodities"
        role="tab"
        aria-controls="v-pills-commodities"
        aria-selected="true"
        >Commodities</a
      >
      <a
        class="nav-link"
        id="v-pills-fruitveg-tab"
        data-toggle="pill"
        href="#v-pills-fruitveg"
        role="tab"
        aria-controls="v-pills-fruitveg"
        aria-selected="false"
        >Fruits &amp; Vegetables</a
      >
      <a
        class="nav-link"
        id="v-pills-livestock-tab"
        data-toggle="pill"
        href="#v-pills-livestock"
        role="tab"
        aria-controls="v-pills-livestock"
        aria-selected="false"
        >Livestock</a
      >
      <a
        class="nav-link"
        id="v-pills-rootstubbers-tab"
        data-toggle="pill"
        href="#v-pills-rootstubbers"
        role="tab"
        aria-controls="v-pills-rootstubbers"
        aria-selected="false"
        >Roots and tubers</a
      >
      <a
        class="nav-link"
        id="v-pills-rootstubbers-tab"
        data-toggle="pill"
        href="#v-pills-rootstubbers"
        role="tab"
        aria-controls="v-pills-rootstubbers"
        aria-selected="false"
        >Trucks & Machinery</a
      >
      <a
        class="nav-link"
        id="v-pills-rootstubbers-tab"
        data-toggle="pill"
        href="#v-pills-rootstubbers"
        role="tab"
        aria-controls="v-pills-rootstubbers"
        aria-selected="false"
        >Warehouse</a
      >
      <a
        class="nav-link"
        id="v-pills-rootstubbers-tab"
        data-toggle="pill"
        href="#v-pills-rootstubbers"
        role="tab"
        aria-controls="v-pills-rootstubbers"
        aria-selected="false"
        >Inputs</a
      >
    </div>
    <p class="mt-4 text-center">
      <font-awesome-icon :icon="['fas', 'headphones-alt']" size="1x" />
      <span class="h6">+234 813 486 0483</span>
    </p>
  </div>
</template>

<script>
export default {};
</script>
